import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStop = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2 20C2 15.2261 3.89642 10.6477 7.27208 7.27208C10.6477 3.89642 15.2261 2 20 2C24.7739 2 29.3523 3.89642 32.7279 7.27208C36.1036 10.6477 38 15.2261 38 20C38 24.7739 36.1036 29.3523 32.7279 32.7279C29.3523 36.1036 24.7739 38 20 38C15.2261 38 10.6477 36.1036 7.27208 32.7279C3.89642 29.3523 2 24.7739 2 20ZM26.75 13.25V26.75H13.25V13.25H26.75Z"
	})
});
export default SvgStop;
